import react from "react";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import logo from '../../../resources/img/logo-2.png';

function CuestionarioPaciente4() {
    
    const [eps, setEps] = useState('');
    const [medio, setMedio] = useState('');
    const [referido, setReferido] = useState('');

    const [listaEps, setListaeps] = useState([]);
    const [listaMedios, setListaMedios] = useState([]);

    const queryParams = useLocation().search;

    const [idPaciente, setIdPaciente] = useState(new URLSearchParams(queryParams).get('id'));
    const [idCliente, setIdCliente] = useState('');
    const [tokenPaciente, setTokenPaciente] = useState(new URLSearchParams(queryParams).get('token'));

    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();

    let history = useHistory();

    let userdata = [];

    useEffect(() => {

        const config = {
            params: {
                id: idPaciente
            }
        }

        axios.get('/paciente-publico',config)
            .then(response => {
                console.log('id cliente: '+response.data[0].id_client);
                setIdCliente(response.data[0].id_client);
                setEps(response.data[0].eps);
                setMedio(response.data[0].medio_publicitario);
                setReferido(response.data[0].referido_por);
            })
            .catch(error => {
                console.log(error);
            })
    },[]);


    useEffect(() => {

        const conf = {
            params: {
                id_cliente: idCliente
            }
        }

        axios.get('/aseguradoras-cliente', conf)
            .then(response => {
                setListaeps(response.data);
            })
            .catch(error => {
                console.log(error);
            })

        axios.get('/medios-publicitarios-cliente', conf)
            .then(response => {
                setListaMedios(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    },[idCliente]);



    const handleSubmit = (e) => {
        e.preventDefault();

        const config = {
            id:idPaciente,
            eps: eps,
            medio_publicitario: medio,
            referido_por: referido
        }

        axios.put('/datos-adicionales',config)
            .then(response => {
                setLoading(false);
                history.push({
                    pathname: '/confirmacion-cuestionario'
                });
            })
            .catch(error => {
                console.log(error.response.data);
                setErrorlist(error.response.data.errors);
            })
    }

    return (
                <div className="contenedor-cuestionario">

                    <div style={{textAlign:'center'}}>
                        <img src={logo} alt="logo smile" width="200" />
                    </div>
                    
                    <div className="row mb-2" style={{marginTop:'30px'}}>
                        <h1 className="m-0" style={{textAlign: 'center', width: '100%'}}>Información personal</h1>
                    </div>

                    <div className="indicador-progreso">
                        <div className="indicador-punto completado">1</div>
                        <div className="indicador-linea completado"></div>
                        <div className="indicador-punto completado">2</div>
                        <div className="indicador-linea completado"></div>
                        <div className="indicador-punto completado">3</div>
                        <div className="indicador-linea completado"></div>
                        <div className="indicador-punto completado">4</div>
                    </div>

                    <form id="quickForm" onSubmit={handleSubmit} autoComplete="off">
                        
                        <div className="card cuestionario-paciente">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                <a className="d-block w-100" data-toggle="collapse" data-target="#infobasica" href="#" style={{textAlign:'center'}}>
                                    Datos adicionales
                                </a>
                                </h4>
                            </div>
                            <div id="infobasica" className="collapse show">
                                <div className="card-body">

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="eps">EPS / Aseguradora</label>
                                                <select name="eps" className="form-control" id="eps" value={eps} onChange={(e) => setEps(e.target.value)}>
                                                    <option value=""></option>
                                                    {
                                                        listaEps.map((item) => 
                                                            <option value={item.id}>{item.nombre}</option>
                                                        )
                                                    }
                                                </select>

                                                <div className="invalid-feedback visible">
                                              
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="medio">¿Cómo se enteró?</label>
                                                <select name="medio" className="form-control" id="medio" value={medio} onChange={(e) => setMedio(e.target.value)}>
                                                    <option value=""></option>
                                                    {
                                                        listaMedios.map((item) => 
                                                            <option value={item.id}>{item.nombre}</option>
                                                        )
                                                    }
                                                </select>
                                                <div className="invalid-feedback visible">
                                              
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="referido">Referido por</label>
                                                <input type="text" name="referido" className="form-control" id="referido" value={referido} onChange={(e) => setReferido(e.target.value)}/>
                                                <div className="invalid-feedback visible">
                                                {errorlist.referido_por}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <button type="submit" className="btn btn-primary" style={{margin: '0 auto', fontSize: '1.4rem'}}>
                                Continuar&nbsp;
                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                            </button>
                        </div>
                    </form>
                </div>
    );
}
export default CuestionarioPaciente4;